import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import moment from 'moment';
import { Row, Col } from 'antd';
import { Animated } from "react-animated-css";

import Top10Category from '../../components/search/top10categorycard';
import Top10MovieTitle from '../../components/search/top10movietitlecard';
import Top10SeriesTitle from '../../components/search/top10seriestitlecard';
import Top10Wording from '../../components/search/top10wordingcard';



import './Search.css';

import {
	
	opensearchTop10MovieTitle,
	opensearchTop10SeriesTitle,
	opensearchTop10Category,
	opensearchTop10Wording

} from '../../modules/search';
import {
	opensearchMovieAll,
	opensearchSeriesAll
} from '../../modules/analytics';

class Search extends Component {
	constructor(props) {
		super(props);
		this.state = {
			loading:false,
			loadingsearchmovie: false,
			loadingsearchtvseries:false,
			loadingsearchcatrgory:false,
			loadingsearchwording:false

		}
	}

	async componentDidMount() {
		const {opensearchTop10MovieTitleList, opensearchTop10SeriesTitleList, opensearchTop10CategoryList, opensearchTop10WordingList,opensearchMovieList, opensearchSeriesList} = this.props;	
		if(!opensearchTop10MovieTitleList){
			await this.getTop10SearchMovieTitleList();
		}
		if(!opensearchTop10SeriesTitleList){
			await this.getTop10SearchSeriesTitleList();
		}
		if(!opensearchTop10CategoryList){
			await this.getTop10SearchCategoryList();
		}
		if(!opensearchTop10WordingList){
			await this.getTop10SearchWordingList();
		}
		if(!opensearchMovieList){
			await this.getOpenMovieList();
		}
		if(!opensearchSeriesList){
			await this.getOpenSeriesList();
		}

	}

	async componentDidUpdate(prevProps) {
		const { opensearchTop10MovieTitleList, opensearchTop10SeriesTitleList, opensearchTop10CategoryList, opensearchTop10WordingList,opensearchMovieList, opensearchSeriesList } = this.props;
		if(!opensearchTop10MovieTitleList && JSON.stringify(opensearchTop10MovieTitleList) !== JSON.stringify(prevProps.opensearchTop10MovieTitleList)){
			await this.getTop10SearchMovieTitleList();
		}
		if(!opensearchTop10SeriesTitleList && JSON.stringify(opensearchTop10SeriesTitleList) !== JSON.stringify(prevProps.opensearchTop10SeriesTitleList)){
			await this.getTop10SearchSeriesTitleList();
		}
		if(!opensearchTop10CategoryList && JSON.stringify(opensearchTop10CategoryList) !== JSON.stringify(prevProps.opensearchTop10CategoryList)){
			await this.getTop10SearchCategoryList();
		}
		if(!opensearchTop10WordingList && JSON.stringify(opensearchTop10WordingList) !== JSON.stringify(prevProps.opensearchTop10WordingList)){
			await this.getTop10SearchWordingList();
		}
		if(!opensearchMovieList && JSON.stringify(opensearchMovieList) !== JSON.stringify(prevProps.opensearchMovieList)){
			await this.getOpenMovieList();
		}
		if(!opensearchSeriesList && JSON.stringify(opensearchSeriesList) !== JSON.stringify(prevProps.opensearchSeriesList)){
			await this.getOpenSeriesList();
		}
	}

	
	getTop10SearchMovieTitleList = async () => {
		const { selectedOrganization, inspectionTime } = this.props;
		this.setState({ loadingsearchmovie: true });
		await this.props.opensearchTop10MovieTitle(`accountName=${selectedOrganization}&gte=${moment(inspectionTime.till).subtract(inspectionTime.day, 'days').toISOString()}&lte=${moment(inspectionTime.till).toISOString()}`);
		this.setState({ loadingsearchmovie: false });
	}
	getTop10SearchSeriesTitleList = async () => {
		const { selectedOrganization, inspectionTime } = this.props;
		this.setState({ loadingsearchtvseries: true });
		await this.props.opensearchTop10SeriesTitle(`accountName=${selectedOrganization}&gte=${moment(inspectionTime.till).subtract(inspectionTime.day, 'days').toISOString()}&lte=${moment(inspectionTime.till).toISOString()}`);
		this.setState({ loadingsearchtvseries: false });
	}
	getTop10SearchCategoryList = async () => {
		const { selectedOrganization, inspectionTime } = this.props;
		this.setState({ loadingsearchcatrgory: true });
		await this.props.opensearchTop10Category(`accountName=${selectedOrganization}&gte=${moment(inspectionTime.till).subtract(inspectionTime.day, 'days').toISOString()}&lte=${moment(inspectionTime.till).toISOString()}`);
		this.setState({ loadingsearchcatrgory: false });
	}
	getTop10SearchWordingList = async () => {
		const { selectedOrganization, inspectionTime } = this.props;
		this.setState({ loadingsearchwording: true });
		await this.props.opensearchTop10Wording(`accountName=${selectedOrganization}&gte=${moment(inspectionTime.till).subtract(inspectionTime.day, 'days').toISOString()}&lte=${moment(inspectionTime.till).toISOString()}`);
		this.setState({ loadingsearchwording: false });
	}
	getOpenMovieList = async () => {
		const { selectedOrganization, inspectionTime } = this.props;
		this.setState({ loading: true });
		await this.props.opensearchMovieAll(`accountName=${selectedOrganization}&gte=${moment(inspectionTime.till).subtract(inspectionTime.day, 'days').toISOString()}&lte=${moment(inspectionTime.till).toISOString()}`);
		this.setState({ loading: false });
	}
	getOpenSeriesList = async () => {
		const { selectedOrganization, inspectionTime } = this.props;
		this.setState({ loading: true });
		await this.props.opensearchSeriesAll(`accountName=${selectedOrganization}&gte=${moment(inspectionTime.till).subtract(inspectionTime.day, 'days').toISOString()}&lte=${moment(inspectionTime.till).toISOString()}`);
		this.setState({ loading: false });
	}

	render() {
		const { loadingsearchmovie, loadingsearchtvseries,loadingsearchcatrgory,loadingsearchwording} = this.state;

		return (
			<Animated animationIn="fadeIn">
				<div className="mainContentWrapper" style={{ paddingBottom: (this.props.play) ? '100px' : '20px' }}>
					<Row>
						<Col md={24} lg={24} xl={24} xxl={24}>
								<Row>
									 <Col span={24}>
										<Top10MovieTitle loading={loadingsearchmovie}/>
									</Col>
								</Row>
								<Row>
									<Col span={24}>
									 	<Top10SeriesTitle loading={loadingsearchtvseries}/>
								 	</Col>
								</Row>
								<Row>
									 <Col span={12}>
										<Top10Category loading={loadingsearchcatrgory}/>
									</Col>
									<Col span={12}>
									 	<Top10Wording loading={loadingsearchwording}/>
								 	</Col>
								</Row>
								
						</Col>
					</Row>
				</div>
			</Animated>
		);
	}


}

const mapStateToProps = state => ({
	router: state.router,
	userProfile: state.user.userProfile,
	selectedOrganization: state.user.selectedOrganization,
	inspectionTime: state.analytics.inspectionTime,
	opensearchTop10MovieTitleList : state.search.opensearchTop10MovieTitleList,
	opensearchTop10SeriesTitleList : state.search.opensearchTop10SeriesTitleList,
	opensearchTop10CategoryList: state.search.opensearchTop10CategoryList,
	opensearchTop10WordingList: state.search.opensearchTop10WordingList,
	opensearchMovieList : state.analytics.opensearchMovieList,
	opensearchSeriesList : state.analytics.opensearchSeriesList
	
	
});

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			opensearchTop10MovieTitle,
			opensearchTop10SeriesTitle,
			opensearchTop10Category,
			opensearchTop10Wording,
			opensearchMovieAll,
			opensearchSeriesAll
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps)(Search);
